/* ----------------Base route--------------------*/
export const BASE_PATH = '/search';

/* ----------------Screen routes--------------------*/
export const RESULTS_PATH_PATTERN = 'results/:tabName/:queryString/*';
export const MAIL_READING_PANE_PATH_PATTERN = 'searchItemId/:itemId/*';
export const COMPOSE_PATH_PATTERN = 'searchComposeId/:composeId/*';
export const CARD_PATH_PATTERN = 'card/:routeIdType/:routeId/:view';
export const ATTACHMENT_PATH_PATTERN = 'attachmentId/:attachmentId';

/* ----------------Results route tab names--------------------*/
export const MAIL_TAB = 'mail';
export const PEOPLE_TAB = 'people';
export const EVENTS_TAB = 'events';

/**
 * List of owa-router routes.
 * TODO: remove below routes after migration from owa-router to react-router v6. WI: 138487.
 */

/* ----------------Mail results routes--------------------*/
export const MAIL_RESULTS_ROUTE = '/results/mail/:queryString';
export const READING_PANE_ROUTE = '/searchItemId/:itemId';
export const COMPOSE_ROUTE = '/searchComposeId/:composeId';
export const CARD_ROUTE = '/card/:routeIdType?/:routeId?/:view';

/* ----------------People results routes--------------------*/
export const PEOPLE_RESULTS_ROUTE = '/results/people/:queryString';

/* ----------------Events results routes--------------------*/
export const EVENTS_RESULTS_ROUTE = '/results/events/:queryString';
